<template>
  <div class="svg-loader"></div>
</template>

<style scoped>
.svg-loader {
  width: 100px;
  height: 100px;
  background-image: var(--loader-svg-dark);
}
</style>
